import { useColumnOrder, useExpanded, useFilters, useFlexLayout, useGlobalFilter, usePagination, useRowState, useSortBy } from 'react-table';
import { useSticky } from 'react-table-sticky';
import { useRowSelect as useRowSelectBase } from './use-row-select-base';
import { useRowSelect as useRowSelectOverride } from './use-row-select-override';
export const defaultSettingHooks = (layoutType, isOverrideRowSelect = true) => {
    const useRowSelect = isOverrideRowSelect ? useRowSelectOverride : useRowSelectBase;
    const defaultHooks = [
        useColumnOrder,
        useFilters,
        useGlobalFilter,
        useSortBy,
        useExpanded,
        usePagination,
        useRowSelect,
        useRowState
    ];
    if (layoutType === 'block') {
        defaultHooks.push(useFlexLayout);
        defaultHooks.push(useSticky); // usual 'position: sticky' doesn't work in block layout
    }
    return defaultHooks;
};
